import { ROOT_SLICE } from './constants';

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

export const selectRootSlice = stateAdmin => stateAdmin[ROOT_SLICE];

export const selectData = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { data } = slice;
	return data;
};

export const selectDataByCustomer = (stateAdmin, { customer }) => {
	const data = selectData(stateAdmin);
	return data[customer] || EMPTY_ARRAY;
};

export const selectBoolMap = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { boolMap } = slice;
	return boolMap;
};

export const selectBoolMapByCustomer = (stateAdmin, { customer } = {}) => {
	const slice = selectRootSlice(stateAdmin);
	const { boolMap } = slice;
	return boolMap[customer] || EMPTY_OBJECT;
};

export const selectIsLoading = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { isLoading } = slice;
	return isLoading;
};

export const selectIsLoaded = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { isLoaded } = slice;
	return isLoaded;
};

export const selectErrorMessage = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { errorMessage } = slice;
	return errorMessage;
};

export default {
	selectData,
	selectDataByCustomer,
	selectBoolMap,
	selectBoolMapByCustomer,
	selectIsLoading,
	selectIsLoaded,
	selectErrorMessage
};
